import Vue from 'vue'
// import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import router from '@/router'
import axiosIdentity from '@utils/axiosIdentity'
import jwtDefaultConfig from './jwtDefaultConfig'

export default class JwtService {
  // Will be used by this service for making API calls
  axiosIns = null

  vm = null

  // jwtConfig <= Will be used by this service
  jwtConfig = { ...jwtDefaultConfig }

  // For Refreshing Token
  isAlreadyFetchingAccessToken = false

  // For Refreshing Token
  subscribers = []

  constructor(axiosIns, jwtOverrideConfig) {
    this.axiosIns = axiosIns
    this.jwtConfig = { ...this.jwtConfig, ...jwtOverrideConfig }
    // this.vm = new Vue()

    // Request Interceptor
    this.axiosIns.interceptors.request.use(
      config => {
        // Get token from sessionStorage
        const accessToken = this.getToken()

        // If token is present add it to request's Authorization Header
        if (accessToken) {
          // eslint-disable-next-line no-param-reassign
          config.headers.Authorization = `${this.jwtConfig.tokenType} ${accessToken}`
        }
        return config
      },
      error => Promise.reject(error),
    )

    // Add request/response interceptor
    this.axiosIns.interceptors.response.use(
      response => response,
      error => {
        // const { config, response: { status } } = error
        const { config, response } = error
        const originalRequest = config

        // if (status === 401) {
        if (response && response.status === 401) {
          if (!this.isAlreadyFetchingAccessToken) {
            this.isAlreadyFetchingAccessToken = true
            this.refreshToken().then(r => {
              this.isAlreadyFetchingAccessToken = false

              // Update accessToken in sessionStorage
              this.setToken(r.data.access_token)
              this.setRefreshToken(r.data.refresh_token)

              this.onAccessTokenFetched(r.data.access_token)
            })
              .catch(err => {
              // DO nothing
                // new-toast
                // this.vm.$toast({
                //   component: ToastificationContent,
                //   props: {
                //     title: 'Error',
                //     icon: 'AlertCircleIcon',
                //     variant: 'danger',
                //     text: 'Token expirado',
                //   },
                // })
                sessionStorage.removeItem('accessToken')
                sessionStorage.removeItem('refreshToken')
                sessionStorage.removeItem('userData')
                sessionStorage.clear();
                router.push({ name: 'auth-login' })
                return Promise.reject(err)
              })
          }
          const retryOriginalRequest = new Promise(resolve => {
            this.addSubscriber(accessToken => {
              // Make sure to assign accessToken according to your response.
              // Check: https://pixinvent.ticksy.com/ticket/2413870
              // Change Authorization header
              originalRequest.headers.Authorization = `${this.jwtConfig.tokenType} ${accessToken}`
              resolve(this.axiosIns(originalRequest))
            })
          })
          return retryOriginalRequest
        }
        // if (error.response.data.message) {
        //   // new-toast
        //   // vm.$toast({
        //   //   component: ToastificationContent,
        //   //   props: {
        //   //     title: 'Error',
        //   //     icon: 'AlertCircleIcon',
        //   //     variant: 'danger',
        //   //     text: err,
        //   //   },
        //   // })
        // }
        if (error.response?.data?.messages) {
          error.response.data.messages.forEach(err => {
            vm.$notify({
              type: 'danger',
              verticalAlign: 'top',
              horizontalAlign: 'center',
              message: err,
            })
          })
        }
        return Promise.reject(error)
      },
    )
  }

  onAccessTokenFetched(accessToken) {
    this.subscribers = this.subscribers.filter(callback => callback(accessToken))
  }

  addSubscriber(callback) {
    this.subscribers.push(callback)
  }

  getToken() {
    return sessionStorage.getItem(this.jwtConfig.storageTokenKeyName)
  }

  getRefreshToken() {
    return sessionStorage.getItem(this.jwtConfig.storageRefreshTokenKeyName)
  }

  setToken(value) {
    sessionStorage.setItem(this.jwtConfig.storageTokenKeyName, value)
  }

  setRefreshToken(value) {
    sessionStorage.setItem(this.jwtConfig.storageRefreshTokenKeyName, value)
  }

  login(...args) {
    return this.axiosIns.post(this.jwtConfig.loginEndpoint, ...args)
  }

  register(...args) {
    return this.axiosIns.post(this.jwtConfig.registerEndpoint, ...args)
  }

  refreshToken() {
    const token = this.getRefreshToken()
    return axiosIdentity.post(this.jwtConfig.refreshEndpoint, new URLSearchParams({
      refresh_token: token,
      grant_type: 'refresh_token',
      client_id: 'Framework',
    }))
  }
}
